import React from 'react'
import { WORKBAR_ACTIONS } from '../constants'
import SupervisorChatExpanded from '../components/workSpace/ExpandedBar/SupervisorChatExpanded';
import NoAvailableRecordExpanded from '../components/workSpace/ExpandedBar/NoAvailableRecordExpanded';
import NoAvailableExpanded from '../components/workSpace/ExpandedBar/NoAvailableExpanded';

export function supervisorChatExpanded(props = {}) {
  return {
    idComponent: WORKBAR_ACTIONS.SUPERVISOR_CHAT,
    componentProps: props,
    component: <SupervisorChatExpanded key="supervisorChatExpanded" id={WORKBAR_ACTIONS.SUPERVISOR_CHAT} objProps={props} />
  }
}
export function noAvailableRecordExpanded(props = {}) {
  return {
    idComponent: WORKBAR_ACTIONS.NO_AVAILABLE_RECORD,
    componentProps: props,
    component: <NoAvailableRecordExpanded key="noAvailableRecordExpanded" id={WORKBAR_ACTIONS.NO_AVAILABLE_RECORD} objProps={props} />
  }
}
export function noAvailableExpanded(props = {}) {
  return {
    idComponent: WORKBAR_ACTIONS.NO_AVAILABLE,
    componentProps: props,
    component: <NoAvailableExpanded key="noAvailableExpanded" id={WORKBAR_ACTIONS.NO_AVAILABLE} objProps={props} />
  }
}



// WEBPACK FOOTER //
// ./src/js/ExpandedComponents.js